import { inject, Injectable } from '@angular/core';
import { BaseFlowsStore } from '@kinet-open-network/client/flows/data-access';
import { ChangePriceFlowStatus } from '@kinet-open-network/shared/data-access/model-pbgas';
import { FlowChangePrices } from './flow-change-prices.model';
import { FlowChangePricesService } from './flow-change-prices.service';

@Injectable()
export class FlowChangePricesStore extends BaseFlowsStore<
  FlowChangePrices,
  'id'
>(FlowChangePricesService) {
  override readonly service = inject(FlowChangePricesService);

  override isTerminalState(status: string): boolean {
    return (
      status === ChangePriceFlowStatus.completed ||
      status === ChangePriceFlowStatus.rejected
    );
  }
}
